module.exports = __webpack_public_path__ + "img/sqlc2TW.ab616337.png";